export default "__VITE_ASSET__A0yK94iJ__"